module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"select":"Выбрать благоприятности"}}')
  delete Component.options._Ctor
}
